import React from 'react';
import { useAppSelector } from '../../../store/hooks/StoreHooks';

interface CaseComparisonTableProps {
    height: number;
}

const CaseComparisonTable: React.FC<CaseComparisonTableProps> = ({ height }) => {

    const { comparisonData1, comparisonData2, comparisonData3, compareInput1, compareInput2, compareInput3, case1SystemTDH, case2SystemTDH, case3SystemTDH } = useAppSelector((state) => state.comparison);
    const { projectAndAffiliations } = useAppSelector((state) => state?.projectHeader);

    return (
        <div className='flex flex-col gap-[16px]'>
            <div className="text-neutral-25">Operating performance</div>

            <div className={`scrollable max-h-[${height}] relative overflow-auto`}
                style={{ background: "var(--Dark-Mode-Gradient-Cards, linear-gradient(181deg, #253240 -16.87%, rgba(37, 48, 64, 0.40) 35.14%))" }}>
                <table className='min-w-full rounded-[8px] outline-[1px] table'>
                    <thead>
                        <tr>
                            <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[40%]'>

                            </th>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[20%]'>
                                <div className="flex items-center">{projectAndAffiliations.find((item: any) => item.projectID === compareInput1)?.displayCaseName}</div>
                            </th>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[20%]'>
                                <div className="flex items-center">{projectAndAffiliations.find((item: any) => item.projectID === compareInput2)?.displayCaseName}</div>
                            </th>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[20%]'>
                                <div className="flex items-center">{projectAndAffiliations.find((item: any) => item.projectID === compareInput3)?.displayCaseName}</div>
                            </th>}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    Total volume at intake
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.totalVolumeIntake ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.totalVolumeIntake ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.totalVolumeIntake ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    Oil rate
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.oilRate ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.oilRate ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.oilRate ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    Water rate
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.waterRate ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.waterRate ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.waterRate ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    Gas rate
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.gasRate ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.gasRate ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.gasRate ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    % Free gas at intake
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.freeGasIntakePercent ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.freeGasIntakePercent ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.freeGasIntakePercent ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    % Free gas at main pump
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.pumpFreeGasPercent ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.pumpFreeGasPercent ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.pumpFreeGasPercent ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    Required system TDH
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData1?.requiredSystemTDH ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData2?.requiredSystemTDH ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData3?.requiredSystemTDH ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    System TDH
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {case1SystemTDH ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {case2SystemTDH ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {case3SystemTDH ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    Motor load %
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData1?.motor_LoadAt60Hz ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData2?.motor_LoadAt60Hz ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData3?.motor_LoadAt60Hz ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    Operating frequency
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData1?.operatingFrequency ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData2?.operatingFrequency ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData3?.operatingFrequency ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    KVA required
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData1?.surface_KvaRequired ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData2?.surface_KvaRequired ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData3?.surface_KvaRequired ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    Sensor set depth (ft MD)
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData1?.pumpSettingMD ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData2?.pumpSettingMD ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className="px-[24px] py-[9px] text-neutral-25 text-[14px]">
                                <div className="flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]">
                                    {comparisonData3?.pumpSettingMD ?? ""}
                                </div>
                            </td>}
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="text-neutral-25">Gas separator</div>
            <div className={`scrollable max-h-[${height}] relative overflow-auto`}
                style={{ background: "var(--Dark-Mode-Gradient-Cards, linear-gradient(181deg, #253240 -16.87%, rgba(37, 48, 64, 0.40) 35.14%))" }}>
                <table className='min-w-full rounded-[8px] outline-[1px] table'>
                    <thead>
                        <tr>
                            <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[40%]'>
                            </th>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[20%]'>
                                <div className="flex items-center">{projectAndAffiliations.find((item: any) => item.projectID === compareInput1)?.displayCaseName}</div>
                            </th>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[20%]'>
                                <div className="flex items-center">{projectAndAffiliations.find((item: any) => item.projectID === compareInput2)?.displayCaseName}</div>
                            </th>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <th className='px-[24px] py-[16px] text-[12px] text-neutral-25 w-[20%]'>
                                <div className="flex items-center">{projectAndAffiliations.find((item: any) => item.projectID === compareInput3)?.displayCaseName}</div>
                            </th>}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px] w-[40%]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    Model
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.gas_GasSeparator ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.gas_GasSeparator ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.gas_GasSeparator ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    % GVF intake
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.freeGasIntakePercent ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.freeGasIntakePercent ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.freeGasIntakePercent ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    % GVF discharge
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.gasSep_FreeGasDischarge ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.gasSep_FreeGasDischarge ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.gasSep_FreeGasDischarge ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    Pressure intake
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.gasSep_PressureIntake ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.gasSep_PressureIntake ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.gasSep_PressureIntake ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    Intake volume
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.gasSep_TVFIntake ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.gasSep_TVFIntake ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.gasSep_TVFIntake ?? ""}
                                </div>
                            </td>}
                        </tr>
                        <tr>
                            <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    Discharge volume
                                </div>
                            </td>
                            {comparisonData1 && Object.values(comparisonData1)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData1?.gasSep_TFVDischarge ?? ""}
                                </div>
                            </td>}
                            {comparisonData2 && Object.values(comparisonData2)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData2?.gasSep_TFVDischarge ?? ""}
                                </div>
                            </td>}
                            {comparisonData3 && Object.values(comparisonData3)?.length > 0 && <td className='px-[24px] py-[9px] text-neutral-25 text-[14px]'>
                                <div className='flex justify-start items-center gap-[8px] text-neutral-25 w-[230px]'>
                                    {comparisonData3?.gasSep_TFVDischarge ?? ""}
                                </div>
                            </td>}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CaseComparisonTable;